import { render, staticRenderFns } from "./DataPreloader.vue?vue&type=template&id=ddf5d7fc&scoped=true"
import script from "./DataPreloader.vue?vue&type=script&lang=js"
export * from "./DataPreloader.vue?vue&type=script&lang=js"
import style0 from "./DataPreloader.vue?vue&type=style&index=0&id=ddf5d7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf5d7fc",
  null
  
)

export default component.exports